const Logo = ({ size = 48, className = "" }) => (
    <svg
        viewBox="0 0 120 120"
        width={size}
        height={size}
        className={className}
        role="img"
        aria-label="Festive Theory logo"
        data-testid="brand-logo"
    >
        <circle cx="60" cy="60" r="58" fill="#E2BA03" />
        <circle cx="60" cy="60" r="52" fill="none" stroke="#F0EEE8" strokeWidth="1" strokeDasharray="2 4" opacity="0.8" />
        {/* bunting across the top */}
        <path d="M16 34 C 40 46, 80 46, 104 34" fill="none" stroke="#472500" strokeWidth="1.4" />
        {[0, 1, 2, 3, 4].map((i) => {
            const x = 28 + i * 16;
            const y = 39.5 - Math.abs(i - 2) * 2.1;
            return (
                <path
                    key={i}
                    d={`M${x - 5.5} ${y} L ${x + 5.5} ${y} L ${x} ${y + 9} Z`}
                    fill={i % 2 === 0 ? "#472500" : "#F0EEE8"}
                    stroke="#472500"
                    strokeWidth="0.8"
                />
            );
        })}
        {/* script wordmark */}
        <text
            x="60"
            y="66"
            textAnchor="middle"
            fill="#FFFFFF"
            fontFamily="'Dancing Script', cursive"
            fontWeight="700"
            fontSize="21"
        >
            festive
        </text>
        <text
            x="60"
            y="87"
            textAnchor="middle"
            fill="#FFFFFF"
            fontFamily="'Dancing Script', cursive"
            fontWeight="700"
            fontSize="21"
        >
            theory
        </text>
        {/* hanging lanterns */}
        <g stroke="#472500" fill="none" strokeWidth="1.2">
            <path d="M26 44 L 26 58" />
            <path d="M21 58 L 31 58 L 29 63 L 23 63 Z" />
            <path d="M21 66 C 21 63, 31 63, 31 66 L 31 78 C 31 81, 21 81, 21 78 Z" />
            <path d="M26 81 L 26 86" />
            <circle cx="26" cy="88.5" r="1.8" />
        </g>
        <g stroke="#472500" fill="none" strokeWidth="1.2">
            <path d="M94 44 L 94 54" />
            <path d="M89 54 L 99 54 L 97 59 L 91 59 Z" />
            <path d="M89 62 C 89 59, 99 59, 99 62 L 99 74 C 99 77, 89 77, 89 74 Z" />
            <path d="M94 77 L 94 82" />
            <circle cx="94" cy="84.5" r="1.8" />
        </g>
    </svg>
);

export default Logo;
